module.exports = __webpack_public_path__ + "static/media/logo.015d6b96.svg";